module.exports = __webpack_public_path__ + "img/C2M.8e9cd2e1.png";